if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) {       
        return;
      } 
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && !this.hasAttribute('data-cto-direct-checkout')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      window.addEventListener('pageshow', () => {
        if (!this.redirecting) return;
        this.redirecting = false;
        this.submitButton.removeAttribute('aria-disabled');
        window.CTOFormUX?.release(this.form);
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Quick views must not bypass the required controls on the full product page.
      if (this.dataset.ctoProperty && !this.form.elements.namedItem(this.dataset.ctoProperty)) {
        window.location.assign(this.dataset.ctoDetailUrl);
        return;
      }

      // Includes external controls linked with form=, even with novalidate.
      const quantity = this.form.elements.namedItem('quantity');
      const maximum = Number(this.dataset.ctoMax || 0);
      if (quantity && maximum) {
        const count = Number(quantity.value);
        quantity.setCustomValidity(Number.isInteger(count) && count >= 1 && count <= maximum ? '' : this.dataset.ctoLimitMessage);
      }
      if (!this.form.reportValidity()) return;
      this.handleErrorMessage();
      this.error = false;

      this.submitButton.setAttribute('aria-disabled', true);
      window.CTOFormUX?.busy(this.form, window.CTOFormUX.copy.adding);
      this.redirecting = false;

      const formData = new FormData(this.form);
      formData.forEach((value, key) => {
        if (key.startsWith('properties[') && value === '') formData.delete(key);
      });
      const isBadalOrder = formData.has('properties[Confirmation d’éligibilité]');
      const frameToggle = document.querySelector('[data-badal-frame-toggle]');
      const frameVariantId = Number.parseInt(frameToggle?.dataset.frameVariantId, 10);
      const addBadalFrame = isBadalOrder && frameToggle?.checked && Number.isFinite(frameVariantId);
      const config = fetchConfig(addBadalFrame ? 'json' : 'javascript');
      if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') config.signal = AbortSignal.timeout(45000);
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      if (addBadalFrame) {
        const properties = {};
        formData.forEach((value, key) => {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            properties[key.slice(11, -1)] = value;
          }
        });

        const quantity = Math.max(1, Number.parseInt(formData.get('quantity'), 10) || 1);
        const payload = {
          items: [
            {
              id: Number.parseInt(formData.get('id'), 10),
              quantity,
              properties,
            },
            {
              id: frameVariantId,
              quantity,
              properties: {
                _badal_frame: 'true',
                _badal_service_variant: String(formData.get('id')),
              },
            },
          ],
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        config.headers['Content-Type'] = 'application/json';
        config.headers.Accept = 'application/json';
        config.body = JSON.stringify(payload);
      } else {
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
      }

      // Check the resulting line, including repeated additions of the same properties.
      // Optional empty properties must compare like Shopify's omitted properties.
      const requestedQuantity = Number(formData.get('quantity') || 1);
      const properties = {};
      formData.forEach((value, key) => {
        if (key.startsWith('properties[') && key.endsWith(']') && value !== '') properties[key.slice(11, -1)] = value;
      });
      const normalizeProperties = values => JSON.stringify(Object.entries(values || {}).filter(([, value]) => value !== '' && value != null).sort(([a], [b]) => a.localeCompare(b)));
      const request = maximum
        ? fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' }, signal: config.signal })
          .then(response => { if (!response.ok) throw new Error('cart'); return response.json(); })
          .then(cart => {
            const existing = cart.items.find(item => String(item.variant_id) === String(formData.get('id')) && normalizeProperties(item.properties) === normalizeProperties(properties) && !item.selling_plan_allocation);
            if ((existing?.quantity || 0) + requestedQuantity > maximum) {
              const error = new Error(this.dataset.ctoLimitMessage);
              error.ctoLimit = true;
              throw error;
            }
            return fetch(`${routes.cart_add_url}`, config);
          })
        : fetch(`${routes.cart_add_url}`, config);
      request
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            window.CTOFormUX?.feedback(this.form, 'error', response.description || window.CTOFormUX.copy.purchase_error).focus();
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          window.CTOAnalytics?.capture('product_added_to_cart', {
            variant_id: String(formData.get('id')),
            quantity: Math.max(1, Number.parseInt(formData.get('quantity'), 10) || 1),
          });
          if (this.hasAttribute('data-cto-direct-checkout')) {
            this.redirecting = true;
            window.CTOFormUX?.busy(this.form, window.CTOFormUX.copy.checkout);
            window.location.assign('/checkout');
            return;
          }
          if (!this.cart) {
            this.redirecting = true;
            window.CTOFormUX?.feedback(this.form, 'success', window.CTOFormUX.copy.added);
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          window.CTOFormUX?.feedback(this.form, 'success', window.CTOFormUX.copy.added);
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            const renderState = response.items?.length
              ? { ...response, ...response.items[0], key: response.items[0].key }
              : response;
            this.cart.renderContents(renderState);
          }
        })
        .catch((e) => {
          const message = e.ctoLimit ? e.message : window.cartStrings?.error || window.CTOFormUX?.copy.purchase_error;
          window.CTOFormUX?.feedback(this.form, 'error', message).focus();
          this.handleErrorMessage(message || 'Impossible d’ajouter cette prestation. Réessayez dans un instant.');
          console.error(e);
        })
        .finally(() => {
          if (this.redirecting) return;
          this.form.removeAttribute('aria-busy');
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get("sticky-add-to-cart")) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this._handleResize = this._debounce(
        this.initStickyAddToCart.bind(this),
        200
      );
    }

    connectedCallback() {
      this.initStickyAddToCart();
      window.addEventListener("resize", this._handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._handleResize);
      if (this._checkVisibility) {
        window.removeEventListener("scroll", this._checkVisibility);
      }
      if (this._stickyForm && this._handleStickySubmit) {
        this._stickyForm.removeEventListener("submit", this._handleStickySubmit, true);
      }
      document.documentElement.classList.remove("sticky-cart-visible");
    }

    initStickyAddToCart() {
      if (this._initialized) {
        this._checkVisibility?.();
        return;
      }

      const img = this.querySelector(".product-content img");
      const selectField = this.querySelector('select[name="id"]');
      const addButton = this.querySelector('button[name="add"]');
      const productForm = Array.from(document.querySelectorAll("product-form.product-form"))
        .find((element) => !element.closest("sticky-add-to-cart"));
      const stickyForm = this.querySelector('form[action*="/cart/add"]');

      if (!selectField || !addButton || !productForm || !stickyForm) return;

      this._initialized = true;
      this._stickyForm = stickyForm;

      const addToCartText = addButton.getAttribute("data-add-to-cart");
      const soldOutText = addButton.getAttribute("data-sold-out");

      const checkVisibility = () => {
        const formRect = productForm.getBoundingClientRect();
        const footer = document.querySelector("footer");
        const footerRect = footer?.getBoundingClientRect();

        const isOutOfView =
          formRect.bottom <= 0 || formRect.top >= window.innerHeight;
        const isFooterVisible =
          footerRect && footerRect.top < window.innerHeight;
        const shouldShow = isOutOfView && !isFooterVisible;

        if (shouldShow) {
          this.classList.add("show");
          this.setAttribute("aria-hidden", "false");
          document.documentElement.style.paddingBottom = `${this.clientHeight}px`;
        } else {
          this.classList.remove("show");
          this.setAttribute("aria-hidden", "true");
          document.documentElement.style.paddingBottom = "0";
        }

        document.documentElement.classList.toggle("sticky-cart-visible", shouldShow);
      };

      this._checkVisibility = checkVisibility;

      checkVisibility();

      window.addEventListener("scroll", checkVisibility, { passive: true });

      this._handleStickySubmit = (event) => {
        const mainForm = productForm.querySelector('form[action*="/cart/add"]');
        const mainFormId = mainForm?.getAttribute("id");
        if (!mainFormId) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const mainButton = mainForm.querySelector('button[type="submit"]');
        if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
        // One form owns the current variant, quantity, properties and validation.
        mainForm.requestSubmit(mainButton);
      };
      stickyForm.addEventListener("submit", this._handleStickySubmit, true);

      selectField.addEventListener("change", () => {
        const selectedOption = selectField.options[selectField.selectedIndex];

        if (selectedOption.dataset.img) {
          img.setAttribute("src", selectedOption.dataset.img);
        }

        if (selectedOption.getAttribute("data-available") === "false") {
          addButton.setAttribute("disabled", "true");
          addButton.querySelector("span").textContent = soldOutText;
        } else {
          addButton.removeAttribute("disabled");
          addButton.querySelector("span").textContent = addToCartText;
        }
      });

      document
        .querySelector('.product-form [name="id"]')
        ?.addEventListener("change", (e) => {
          const value = Number(e.target.value);
          if (value) {
            selectField.value = value;
          }
        });
    }

    _debounce(func, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }

  customElements.define("sticky-add-to-cart", StickyAddToCart);
}

